import axios from "axios";
import { useState, useCallback } from "react";
import Base from "../BaseTemplate";

// Custom hooks
export default function useAPI() {
  const [error, setError] = useState(null);

  const apiCall = useCallback(async (config) => {
    setError(null);

    try {
      const token = localStorage.getItem("token");
      const response = await axios({
        ...config,
        headers: {
          Authorization: `Bearer ${token}`,
          ...config.headers,
        },
      });
      return response.data;
    } catch (err) {
      console.error("API Error:", err);
      setError(err.response?.data?.message || "An error occurred");
      throw err;
    }
  }, []);

  return { apiCall, error };
}
